import * as React from 'react';
import classNames from 'classnames';
import styles from './Icon.module.esm.js';

var InvitaeIcon = function (_a) {
    var _b;
    var iconName = _a.iconName, _c = _a.size, size = _c === void 0 ? 'medium' : _c, _d = _a.nonDsm, nonDsm = _d === void 0 ? false : _d;
    // allow use of non-dsm Icons without breaking functionality
    var icon = nonDsm ? "icon-".concat(iconName) : "icon-dsm-".concat(iconName);
    return React.createElement("div", { className: classNames(styles['icon'], icon, (_b = {}, _b[styles[size]] = size, _b)), role: "presentation" });
};

export { InvitaeIcon };
//# sourceMappingURL=InvitaeIcon.esm.js.map
